import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from '~/redux';
import { styled } from '~/styles';
import { Stylable } from '~/types';

import GenericUserImage from '~/assets/images/user_placeholder.png';


const StyledUsername = styled(Link)`
  white-space: nowrap;
`

interface Props extends Stylable {}
const UsernameWithAvatar: React.FC<Props> = ({ className }) => {
  const user = useSelector((state) => state.user);
  return (<>
    {
      !!user && user.confirmed ?
        <StyledUsername to='#!' className={className}>
          {/* <img src={user.profileImageURLSmall} alt='' />&nbsp; */}
          <img src={GenericUserImage} alt='' />&nbsp;
          {/* <span>{user.firstName}</span>&nbsp;
          <span>{user.lastName}</span> */}
          <span>{user.firstName}</span>
        </StyledUsername> :
        <StyledUsername to='#!' className={className}>
          <span>Logged In</span>
        </StyledUsername>
    }
  </>)
}
export default UsernameWithAvatar;



// WEBPACK FOOTER //
// ./src/components/links/UsernameWithAvatar.tsx